<template>
  <div class="ma-3">
    <h1>403 ERROR, Forbidden</h1>
  </div>
</template>

<script>

export default {
  created() {
    this.axios.get('httpstatus')
      .then(() => {
        this.$router.push(localStorage.getItem('lastUserPath') || '/login');
      })
      .catch(() => {});
  },
}
</script>




// WEBPACK FOOTER //
// src/components/Vpn/VpnDisconnected.vue